var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center justify-content-center"},[_c('img',{staticClass:"mb-2",attrs:{"src":"/spinner.gif","alt":"Loading"}}),_vm._v(" "),_c('span',{staticClass:"text-grey",domProps:{"textContent":_vm._s(`${_vm.text}...`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }